<template>
  <div class="blog-list">
    <article v-for="item in items" :key="item.href" class="blog-card">
      <p class="meta">{{ item.date }}</p>
      <h2 class="title">
        <NuxtLink :to="item.href">{{ item.title }}</NuxtLink>
      </h2>
      <p class="description">{{ item.description }}</p>
      <NuxtLink :to="item.href" class="read-more">{{ readMoreLabel }}</NuxtLink>
    </article>

    <p v-if="items.length === 0" class="empty-text">{{ emptyText }}</p>
  </div>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    default: () => []
  },
  emptyText: {
    type: String,
    default: ''
  },
  readMoreLabel: {
    type: String,
    default: ''
  }
});
</script>

<style scoped lang="scss">
.blog-list {
  display: grid;
  gap: $spacing-lg;
}

.blog-card {
  background: $white;
  border: 1px solid $gray-200;
  border-radius: $border-radius-md;
  padding: $spacing-lg;

  .meta {
    margin: 0 0 $spacing-xs;
    color: $gray-500;
    font-size: 12px;
  }

  .title {
    margin: 0 0 $spacing-sm;
    font-size: 1.25rem;

    a {
      color: $gray-900;
      text-decoration: none;

      &:hover {
        color: $primary-color;
      }
    }
  }

  .description {
    margin: 0 0 $spacing-md;
    color: $gray-700;
    line-height: 1.6;
  }

  .read-more {
    color: $primary-color;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.empty-text {
  margin: 0;
  color: $gray-500;
}
</style>
